import type { VoiceOption } from "../views/useSimoChat";

export function voiceSelectionStatus(input: {
  selected?: VoiceOption;
  elevenConfigured: boolean;
}): { label: string; detail: string; action: string; testLabel: string; playback: string; selectedLabel: string; playbackLabel: string; reason: string } {
  const selected = input.selected;
  if (!selected) {
    return {
      label: "Stimme nicht gefunden",
      detail: "SIMO nutzt Piper lokal als sicheren Fallback.",
      action: "Fallback aktiv",
      testLabel: "Piper testen",
      playback: "Audio nutzt Piper lokal.",
      selectedLabel: "Auswahl nicht gefunden",
      playbackLabel: "Piper lokal",
      reason: "Gespeicherte Stimme ist nicht mehr in der Backend-Liste.",
    };
  }
  if (selected.available === false) {
    return {
      label: `${selected.label} nicht verfügbar`,
      detail: selected.unavailableReason ?? "Diese Stimme ist aktuell nicht konfiguriert.",
      action: selected.actionLabel ?? "Setup prüfen",
      testLabel: "Piper testen",
      playback: "Auswahl bleibt sichtbar; Audio nutzt Piper lokal.",
      selectedLabel: selected.label,
      playbackLabel: "Piper lokal",
      reason: selected.unavailableReason ?? "Diese Stimme ist aktuell nicht konfiguriert.",
    };
  }
  if (selected.provider === "eleven" && !input.elevenConfigured) {
    return {
      label: `${selected.label} nicht verfügbar`,
      detail: "ElevenLabs ist nicht konfiguriert; SIMO nutzt Piper lokal.",
      action: "ElevenLabs-Key hinterlegen",
      testLabel: "Piper testen",
      playback: "Auswahl bleibt sichtbar; Audio nutzt Piper lokal.",
      selectedLabel: selected.label,
      playbackLabel: "Piper lokal",
      reason: "ElevenLabs-Key fehlt oder wurde vom Backend nicht als konfiguriert gemeldet.",
    };
  }
  return {
    label: `${selected.label} aktiv`,
    detail: selected.fallback ? "Lokale Fallback-Stimme ist auswählbar und testbar." : "Cloud-Stimme ist auswählbar und testbar.",
    action: selected.actionLabel ?? "Test sprechen",
    testLabel: "Stimme testen",
    playback: selected.fallback ? "Audio nutzt Piper lokal." : "Audio nutzt die ausgewählte Cloud-Stimme.",
    selectedLabel: selected.label,
    playbackLabel: selected.fallback ? "Piper lokal" : selected.label,
    reason: selected.fallback ? "Lokale Stimme ist direkt verfügbar." : "Backend meldet die Cloud-Stimme als verfügbar.",
  };
}
